module.exports = "query location($address: AddressInput!) {\n  location(address: $address) {\n    marketCode\n  }\n}\n"